<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />


    <div v-show="!modoVisualizacao">
        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
                <div class="form-item">
                    <label class="label-caption">Pesquisa Nome</label>
                    <input type="text" v-model="nmPesquisa" maxlength="60" v-uppercase />
                </div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th class="col-width-integer">Cobrança</th>
                    <th class="col-width-date">Data</th>
                    <th>Nome</th>
                    <th class="col-width-char15">Cpf/Cnpj</th>
                    <th class="col-width-number">R$ Total</th>
                    <th class="col-width-number">R$ Recebido</th>
                    <th class="col-width-number">R$ À Receber</th>
                    <th class="col-width-char30">Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  @click="setVisualizar(obj)">
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.cdcobranca) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtcobranca) }}</td>
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-char20 center">{{ obj.cpfcnpj }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vltotal) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlrecebido) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlareceber) }}</td>
                    <td class="col-width-char30">{{ obj.nmsituacao }}</td>
                </tr>
            </tbody>
        </table>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoVisualizacao">
        <CobrancaViewPage :idView="idView" @close="modoVisualizacao = false" @save="lerDados()" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import CobrancaViewPage from './CobrancaViewPage.vue';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const errorMessage = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);
const nmPesquisa = ref(null);
const showPagination = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        errorMessage.value = null;
        isLoading.value = true;
        const req = await genericPost('/financeiro/cobrancas/lista', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate,
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){errorMessage.value=error;
    } finally {isLoading.value = false;}
}

const setVisualizar = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>
